<template>
    <div class="grin-container">
        <g-level vertical-align="top">
            <g-level-item>
                <div>
                    <g-typography v-if="!skipSteps" tag="div" color="info">
                        STEP {{ currentStep }} OF {{ totalSteps }}
                    </g-typography>
                    <g-typography v-if="title && !isLoading" tag="h1" font-weight="semibold">
                        {{ title }}
                    </g-typography>
                </div>
            </g-level-item>
            <template slot="right">
                <g-button
                    shape="circle"
                    icon="times"
                    theme="live"
                    size="large"
                    data-testid="step-header-close-button"
                    :disabled="isPreview"
                    @click="attemptExit"
                />
            </template>
        </g-level>
        <global-exit-modal
            :visible="exitModal"
            @global-modal-exit="continueToExit"
            @global-modal-cancel="preventExit"
        />
    </div>
</template>

<script>
    import GlobalExitModal from './GlobalExitModal';
    import GlobalExitModalMixin from '../mixins/GlobalExitModalMixin';
    import ActivationBriefProgressMixin from '../mixins/ActivationBriefProgressMixin';

    export default {
        name:       'StepHeader',
        components: {
            GlobalExitModal,
        },
        mixins: [
            GlobalExitModalMixin,
            ActivationBriefProgressMixin,
        ],
        props: {
            title: {
                type:    String,
                default: '',
            },
            isLoading: {
                type:    Boolean,
                default: false,
            },
            skipSteps: {
                type:    Boolean,
                default: false,
            },
            isPreview: {
                type: Boolean,
                default: false,
            },
            exitRoute: {
                type: String,
                default: 'v2.activation.brief.overview'
            }
        },
        methods: {
            continueToExit() {
                this.$router.push({ name: this.exitRoute });
            }
        }
    };
</script>

<style lang="scss" scoped>
    .grin-container {
        background-color: $g-color-grey-3;
        padding: $g-spacing-6;
        margin: -$g-spacing-6;
    }
</style>
